// the likelihood drawer will vary from city to city
import ToledoLeadLikelihoodDrawer from "./toledo.js"
import RichmondLeadLikelihoodDrawer from "./richmond.js"

export const LeadLikelihoodDrawer = (
  process.env.REACT_APP_CITY==="TOLEDO"
) ? ToledoLeadLikelihoodDrawer : RichmondLeadLikelihoodDrawer;

export default LeadLikelihoodDrawer;
